import { useContext } from 'react';
import { useParams } from 'react-router-dom';

import { translate } from '@openclassrooms/translations';
import { QuizLearningStatus } from '../LearningStatus';
import useQuizLearningStatus from '../../hooks/useQuizLearningStatus';
import CourseContext from '../../contexts/courseContext';
import type { PartType } from '../../types';
import TocItemWrapper from './TocItemWrapper';

export interface Props {
  quizPart: PartType;
  isOnHomePage: boolean;
  onClick?: () => void;
}

const QuizTocItem = ({ quizPart, isOnHomePage, onClick = () => {} }: Props) => {
  const { id, title, learningActivityStatus } = quizPart;
  const { exerciseId } = useParams<string>();
  const { course } = useContext(CourseContext);
  const { categoryColor } = course;

  const { status: quizLearningStatus } = useQuizLearningStatus({
    initialStatus: learningActivityStatus,
    isOnHomePage,
  });

  const isCurrentDisplayed = id === Number(exerciseId);

  const Icon = <QuizLearningStatus status={quizLearningStatus} color={categoryColor} />;

  return (
    <TocItemWrapper
      isCurrentDisplayed={isCurrentDisplayed}
      part={quizPart}
      label={translate('course_toc.quiz.label', { label: title })}
      onClick={onClick}
      learningStatusIcon={Icon}
    />
  );
};

export default QuizTocItem;
